'use strict';
/**
 * Dependencies
 */

var _slicedToArray = require("/codebuild/output/src3217108893/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/codebuild/output/src3217108893/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src3217108893/src/labourteq/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var splitNameEmail = require('../helpers/split-name-email');
/**
 * Email address class
 */


var EmailAddress = /*#__PURE__*/function () {
  /**
  * Constructor
  */
  function EmailAddress(data) {
    _classCallCheck(this, EmailAddress);

    //Construct from data
    if (data) {
      this.fromData(data);
    }
  }
  /**
   * From data
   */


  _createClass(EmailAddress, [{
    key: "fromData",
    value: function fromData(data) {
      //String given
      if (typeof data === 'string') {
        var _splitNameEmail = splitNameEmail(data),
            _splitNameEmail2 = _slicedToArray(_splitNameEmail, 2),
            _name = _splitNameEmail2[0],
            _email = _splitNameEmail2[1];

        data = {
          name: _name,
          email: _email
        };
      } //Expecting object


      if (typeof data !== 'object') {
        throw new Error('Expecting object or string for EmailAddress data');
      } //Extract name and email


      var _data = data,
          name = _data.name,
          email = _data.email; //Set

      this.setEmail(email);
      this.setName(name);
    }
    /**
     * Set name
     */

  }, {
    key: "setName",
    value: function setName(name) {
      if (typeof name === 'undefined') {
        return;
      }

      if (typeof name !== 'string') {
        throw new Error('String expected for `name`');
      } // Wrap name in quotes to address API issue
      // https://github.com/sendgrid/sendgrid-csharp/issues/268#issuecomment-232177443


      var isQuoted = name[0] === '\"' && name[name.length - 1] === '\"';
      var shouldQuote = name.includes(',') && !isQuoted;
      this.name = shouldQuote ? "\"".concat(name, "\"") : name;
    }
    /**
     * Set email (mandatory)
     */

  }, {
    key: "setEmail",
    value: function setEmail(email) {
      if (typeof email === 'undefined') {
        throw new Error('Must provide `email`');
      }

      if (typeof email !== 'string') {
        throw new Error('String expected for `email`');
      }

      this.email = email;
    }
    /**
    * To JSON
    */

  }, {
    key: "toJSON",
    value: function toJSON() {
      //Get properties
      var email = this.email,
          name = this.name; //Initialize with mandatory properties

      var json = {
        email: email
      }; //Add name if present

      if (name !== '') {
        json.name = name;
      } //Return


      return json;
    }
    /**************************************************************************
     * Static helpers
     ***/

    /**
     * Create an EmailAddress instance from given data
     */

  }], [{
    key: "create",
    value: function create(data) {
      var _this = this;

      //Array?
      if (Array.isArray(data)) {
        return data.filter(function (item) {
          return !!item;
        }).map(function (item) {
          return _this.create(item);
        });
      } //Already instance of EmailAddress class?


      if (data instanceof EmailAddress) {
        return data;
      } //Create instance


      return new EmailAddress(data);
    }
  }]);

  return EmailAddress;
}(); //Export class


module.exports = EmailAddress;